'use client';

import React, { PropsWithChildren, useEffect, useRef } from 'react';

interface ClientRightColumnProps extends PropsWithChildren {
  className?: string;
}

const ClientRightColumn = ({ children, className }: ClientRightColumnProps) => {
  const composantRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      // Vérifie si on est en haut de la page
      if (document.documentElement.scrollTop === 0 && composantRef.current) {
        // Scroll vers le composant
        composantRef.current.scrollTop = 0;
      }
    };

    // Écoute le scroll
    document.addEventListener('scroll', handleScroll);

    // Nettoyage de l'écouteur quand le composant est démonté
    return () => document.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={className} ref={composantRef}>
      {children}
    </div>
  );
};

export default ClientRightColumn;
